import React, {useEffect, useState} from "react";
import {FaPlus, FaXmark} from "react-icons/fa6";
import Button from "../../../components/button";
import InputText from "../../../components/input-text";

const AddCardForm = ({id, onAdd, openRequest = 0}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [title, setTitle] = useState("");

    useEffect(() => {
        if (openRequest > 0) setIsOpen(true);
    }, [openRequest]);

    const submit = event => {
        event.preventDefault();
        const normalizedTitle = title.trim();
        if (!normalizedTitle) return;
        onAdd(normalizedTitle);
        setTitle("");
        setIsOpen(false);
    };

    const handleKeyDown = event => {
        if (event.key !== "Enter" || event.shiftKey) return;
        event.preventDefault();
        event.currentTarget.form?.requestSubmit();
    };

    if (!isOpen) {
        return (
            <Button type="button" onClick={() => setIsOpen(true)} col="w-full !justify-start !border-0 !bg-transparent !shadow-none !px-2 text-slate-500 hover:!bg-slate-200/70">
                <FaPlus /> Adicionar cartão
            </Button>
        );
    }

    return (
        <form onSubmit={submit} className="rounded-lg border border-slate-200 bg-white p-2 shadow-sm">
            <InputText id={id} label="Título do cartão" value={title} onChange={({target}) => setTitle(target.value)} onKeyDown={handleKeyDown} height="h-16" autoFocus />
            <div className="mt-2 flex items-center gap-2">
                <Button type="submit" target="primary">Adicionar</Button>
                <Button type="button" aria-label="Cancelar" onClick={() => setIsOpen(false)} col="!px-2"><FaXmark /></Button>
            </div>
        </form>
    );
};

export default AddCardForm;
